const AdmeetRoutes = {
  register: "/admeet/register",
  getAllAdleaks: "/blog/getallblogsWEB",
}

export default AdmeetRoutes;